import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { getFulfillmentOrderTripDetailsForAdminApi } from './getFulfillmentOrderTripDetailsForAdmin.api'
import getFulfillmentOrderTripDetailsForAdminInitialState from './getFulfillmentOrderTripDetailsForAdmin.initialState'
import {
  GetFulfillmentOrderTripDetailsForAdminErrorResponse,
  GetFulfillmentOrderTripDetailsForAdminRequestPayload
} from './getFulfillmentOrderTripDetailsForAdmin.types'

export const getFulfillmentOrderTripDetailsForAdmin = createAsyncThunk(
  urls.admin.getFulfillmentOrderTripDetailsForAdmin,
  async (payload: GetFulfillmentOrderTripDetailsForAdminRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getFulfillmentOrderTripDetailsForAdminApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse, undefined, true)

      return rejectWithValue(error)
    }
  }
)

const getFulfillmentOrderTripDetailsForAdminSlice = createSlice({
  name: urls.admin.getFulfillmentOrderTripDetailsForAdmin,
  initialState: getFulfillmentOrderTripDetailsForAdminInitialState,
  reducers: {
    resetGetFulfillmentOrderTripDetailsForAdmin: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFulfillmentOrderTripDetailsForAdmin.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getFulfillmentOrderTripDetailsForAdmin.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getFulfillmentOrderTripDetailsForAdmin.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetFulfillmentOrderTripDetailsForAdminErrorResponse
        state.success = null
      })
  }
})

export const {
  actions: getFulfillmentOrderTripDetailsForAdminActions,
  reducer: getFulfillmentOrderTripDetailsForAdminReducer
} = getFulfillmentOrderTripDetailsForAdminSlice
export const { resetGetFulfillmentOrderTripDetailsForAdmin } = getFulfillmentOrderTripDetailsForAdminActions
export default getFulfillmentOrderTripDetailsForAdminSlice.reducer
